import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";

import { isStateLimited, state_array as STATES, state_array } from "../../variables/Variables";
import React from "react";
import styled from "styled-components";

const StyledStateDesc = styled.div`
  font-family: 'InterRegular';
  font-style: italic;
  font-size: 12px;
  margin-bottom: 16px;
  margin-top: -16px;
`;

export default function Address({ id, isCorpAddress, isCountyRequired, noCounty, header, state, onChange }) {
  function handleChange(event) {
    const { id: _id, value } = event.target;
    const inputElement = document.getElementById(_id);
    const errorElement = inputElement.nextSibling;

    if (_id === id + "Address1") {
      if (value.trim().length === 0) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The Address field should not be empty";
        errorElement.style.display = "block";
      } else if (!/^[ a-zA-Z0-9\\/-]+$/.test(value)) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The Address field should contain only letters, numbers, dash or slash";
        errorElement.style.display = "block";
      } else if (
        isCorpAddress &&
        (!/(?!.*(?:[pP][oO] [bB][oO][xX]))^[ a-zA-Z0-9\\/-]+$/.test(value) ||
          !/(?!.*(?:[pP][oO][bB][oO][xX]))^[ a-zA-Z0-9\\/-]+$/.test(value) ||
          !/(?!.*(?:[pP][oO][sS][tT] [oO][fF][fF][iI][cC][eE] [bB][oO][xX]))^[ a-zA-Z0-9\\/-]+$/.test(value) ||
          /\bP(ost|ostal)?([ \.]*(O|0)(ffice)?)?([ \.]*Box)\b/i.test(value))
      ) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "PO Boxes are not acceptable.";
        errorElement.style.display = "block";
      } else {
        errorElement.style.display = "none";
        inputElement.classList.remove("is-invalid");
      }
    }

    if (_id === id + "Address2") {
      if (value.trim().length !== 0) {
        if (!/^[ a-zA-Z0-9\\/-]+$/.test(value)) {
          inputElement.classList.add("is-invalid");
          errorElement.innerHTML = "The Address field should contain only letters, numbers, dash or slash";
          errorElement.style.display = "block";
        } else if (
          isCorpAddress &&
          (!/(?!.*(?:[pP][oO] [bB][oO][xX]))^[ a-zA-Z0-9\\/-]+$/.test(value) ||
            !/(?!.*(?:[pP][oO][bB][oO][xX]))^[ a-zA-Z0-9\\/-]+$/.test(value) ||
            !/(?!.*(?:[pP][oO][sS][tT] [oO][fF][fF][iI][cC][eE] [bB][oO][xX]))^[ a-zA-Z0-9\\/-]+$/.test(value) ||
            /\bP(ost|ostal)?([ \.]*(O|0)(ffice)?)?([ \.]*Box)\b/i.test(value))
        ) {
          inputElement.classList.add("is-invalid");
          errorElement.innerHTML = "PO Boxes are not acceptable.";
          errorElement.style.display = "block";
        } else {
          errorElement.style.display = "none";
          inputElement.classList.remove("is-invalid");
        }
      } else {
        errorElement.style.display = "none";
        inputElement.classList.remove("is-invalid");
      }
    }

    if (_id === id + "City") {
      if (value.trim().length === 0) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The City field should not be empty";
        errorElement.style.display = "block";
      } else if (!/^[ a-zA-Z/-]+$/.test(value)) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The City field should contain only letters";
        errorElement.style.display = "block";
      } else {
        errorElement.style.display = "none";
        inputElement.classList.remove("is-invalid");
      }
    }

    if (_id === id + "County" && isCountyRequired) {
      if (value.trim().length === 0) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The County field should not be empty";
        errorElement.style.display = "block";
      } else if (!/^[ a-zA-Z&-]+$/.test(value)) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The County field should contain only letters, & and dash symbols";
        errorElement.style.display = "block";
      } else {
        errorElement.style.display = "none";
        inputElement.classList.remove("is-invalid");
      }
    }

    if (_id === id + "County" && !isCountyRequired) {
      if (value.trim().length !== 0) {
        if (!/^[ a-zA-Z&-]+$/.test(value)) {
          inputElement.classList.add("is-invalid");
          errorElement.innerHTML = "The County field should contain only letters, & and dash symbols";
          errorElement.style.display = "block";
        } else {
          errorElement.style.display = "none";
          inputElement.classList.remove("is-invalid");
        }
      } else {
        errorElement.style.display = "none";
        inputElement.classList.remove("is-invalid");
      }
    }

    onChange(event);
  }

  return (
    <div>
      {header ? <h5>{header}</h5> : null}
      <OverlayTrigger
        rootClose
        placement="right-start"
        trigger={isCorpAddress ? ["hover"] : ""}
        overlay={
          <Tooltip id="overlay-example" className="helpTooltip">
            <strong>Address</strong>
            <br />
            {state.code === "EIN_Estate" ? (
              <>Enter the street address of the person that will manage the Estate</>
            ) : (
              <>
                Please enter the physical address of the{" "}
                {state.code === "EIN_Trust"
                  ? "Trustee"
                  : state.code === "EIN_Church"
                  ? "Church"
                  : state.code === "EIN_NonProfit"
                  ? "Non Profit"
                  : "business/entity"}
              </>
            )}
            . This cannot be a PO box. It can be changed at a later date.
          </Tooltip>
        }
      >
        <Form.Group controlId={id + "Address1"}>
          <Form.Label>Address</Form.Label>
          <Form.Control
            required
            data-hj-allow
            type="text"
            placeholder="Address"
            maxLength="30"
            pattern={
              isCorpAddress ? `(?!.*(?:[pP][oO] [bB][oO][xX]))^[ a-zA-Z0-9\\\\\\/\\-]+$` : "^[ a-zA-Z0-9\\/\\-]+$"
            }
            defaultValue={state[id + "Address1"]}
            onChange={handleChange}
          />
          <Form.Control.Feedback type="invalid">
            {isCorpAddress
              ? "The only special characters allowed in the Street field are - and /. PO Boxes are not acceptable."
              : "The only special characters allowed in the Street field are - and /"}
          </Form.Control.Feedback>
        </Form.Group>
      </OverlayTrigger>
      <Form.Group controlId={id + "Address2"}>
        <Form.Label>Address 2</Form.Label>
        <Form.Control
          data-hj-allow
          type="text"
          placeholder="Address"
          maxLength="30"
          pattern={
            isCorpAddress
              ? "(?!.*(?:[pP][oO] [bB][oO][xX] | ?:[pP][oO][bB][oO][xX]))^[ a-zA-Z0-9\\\\/-]+$"
              : "^[ a-zA-Z0-9\\/-]+$"
          }
          defaultValue={state[id + "Address2"]}
          onChange={handleChange}
        />
        <Form.Control.Feedback type="invalid">
          {isCorpAddress
            ? "The only special characters allowed in the Street field are - and /. PO Boxes are not acceptable."
            : "The only special characters allowed in the Street field are - and /"}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group controlId={id + "City"}>
        <Form.Label>City</Form.Label>
        <Form.Control
          required
          data-hj-allow
          type="text"
          placeholder="City"
          maxLength="30"
          pattern="^[ a-zA-Z\\/\\-]+$"
          defaultValue={state[id + "City"]}
          onKeyPress={(event) => {
            if (!/[ a-zA-Z/-]/.test(event.key)) event.preventDefault();
          }}
          onChange={handleChange}
        />
        <Form.Control.Feedback type="invalid">Please provide a city name</Form.Control.Feedback>
      </Form.Group>
      <Form.Group controlId={id + "Zip"}>
        <Form.Label>Zip</Form.Label>
        <Form.Control
          required
          data-hj-allow
          type="text"
          maxLength="5"
          placeholder="Zip"
          pattern="\d{5}"
          defaultValue={state[id + "Zip"]}
          onKeyPress={(event) => {
            if (!/[0-9]/.test(event.key)) event.preventDefault();
          }}
          onChange={onChange}
        />
        <Form.Control.Feedback type="invalid">Please provide a zip code.</Form.Control.Feedback>
      </Form.Group>
      {state.code==="EIN_LLC" && isStateLimited(state.organizedState) ? <>
        <Form.Group controlId={id + "State"}>
          <Form.Label>State</Form.Label>
          <Form.Control
            required
            as="select"
            className="form-control"
            name={id + "State"}
            value={state[id + "State"]}
            disabled
            onChange={onChange}
          >
            <option value="">Select a state</option>
            {Object.keys(state_array).map((prop, key) => {
              return (
                <option key={key} value={prop}>
                  {state_array[prop]}
                </option>
              );
            })}
          </Form.Control>
          <Form.Control.Feedback type="invalid">Please select State.</Form.Control.Feedback>
        </Form.Group>
        <StyledStateDesc className="form-group">
          For {STATES[state.organizedState] || 'this state'} filings, the
          physical address must be located within the state.
        </StyledStateDesc>
      </>: <Form.Group controlId={id + "State"}>
          <Form.Label>State</Form.Label>
          <Form.Control
            required
            as="select"
            className="form-control"
            name={id + "State"}
            value={state[id + "State"]}
            onChange={onChange}
          >
            <option value="">Select a state</option>
            {Object.keys(state_array).map((prop, key) => {
              return (
                <option key={key} value={prop}>
                  {state_array[prop]}
                </option>
              );
            })}
          </Form.Control>
          <Form.Control.Feedback type="invalid">Please select State.</Form.Control.Feedback>
        </Form.Group>}
      {noCounty ? null : (
        <OverlayTrigger
          rootClose
          placement="right-start"
          overlay={
            <Tooltip id="overlay-example" className="helpTooltip">
              <strong>County</strong>
              <br />
              {state.code === "EIN_Estate" ? (
                <>Enter the county of the person that will manage the Estate.</>
              ) : (
                <>
                  Enter the county of the{" "}
                  {state.code === "EIN_Trust"
                    ? "Trustee"
                    : state.code === "EIN_Church"
                    ? "Church"
                    : state.code === "EIN_NonProfit"
                    ? "Non Profit"
                    : "business"}
                  .
                </>
              )}
              <br />
              <strong>Do not confuse “county” with “country”.</strong>
            </Tooltip>
          }
        >
          <Form.Group controlId={id + "County"}>
            <Form.Label>County</Form.Label>
            {isCountyRequired ? (
              <Form.Control
                required
                data-hj-allow
                type="text"
                placeholder="County"
                autoComplete="none"
                pattern="^[ a-zA-Z&\\-]+$"
                defaultValue={state[id + "County"]}
                onKeyPress={(event) => {
                  if (!/[ a-zA-Z&-]/.test(event.key)) event.preventDefault();
                }}
                onChange={handleChange}
              />
            ) : (
              <Form.Control
                data-hj-allow
                type="text"
                placeholder="County"
                autoComplete="none"
                pattern="^[ a-zA-Z&\\-]+$"
                value={state[id + "County"]}
                onKeyPress={(event) => {
                  if (!/[ a-zA-Z&-]/.test(event.key)) event.preventDefault();
                }}
                onChange={handleChange}
              />
            )}
            <Form.Control.Feedback type="invalid">Please provide a County.</Form.Control.Feedback>
          </Form.Group>
        </OverlayTrigger>
      )}
    </div>
  );
}
